import { observer } from "mobx-react-lite";
import Layout, { Body, Item, Footer, Control } from "../cmp/layout";
import Button from "../cmp/button";
import Field from "../cmp/field";
import useNav from "../hook/nav";
import useLogin from "./hook";
import Err from "../cmp/err";

function Login() {
	const { reset, signup, partner } = useNav();
	const { value, handlers, msg, wait, submit } = useLogin();
	return <Layout id='auth' title='Авторизация' onSubmit={submit}>
		<Body>
			<Item>
				<Field err={msg.login} disabled={wait} label='Логин' autoComplete='username' icon='user' type='layer1' placeholder="Введите логин" value={value.login} onChange={handlers.login} />
			</Item>
			<Item>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
					<Field err={msg.password} disabled={wait} label='Пароль' autoComplete='current-password' content='password' icon='key' type='layer1' placeholder="Введите пароль" value={value.password} onChange={handlers.password} />
					<Button disabled={wait} children='Забыли пароль?' type='link2' onClick={reset} style={{ alignSelf: 'flex-end' }} />
				</div>
			</Item>
		</Body>
		<Err>{msg.query}</Err>
		<Control center>
			<Button disabled={wait} children='Регистрация' type='base-reverse' onClick={signup} />
			<Button disabled={wait} children='Войти' type='base' onClick={submit} />
		</Control>
		<Footer>
			<span>Вы представляете организацию?</span>
			<Button disabled={wait} children='Стать партнером' type='link-below' onClick={partner} />
		</Footer>
	</Layout>
}

export default observer(Login);